module.exports = __webpack_public_path__ + "img/ph.0394a95d.svg";